import onetime from "@-/com.npmjs.onetime";

import type { GraphemePinyinImageEntry } from "#types";

function pronunciationKey(character: string, toneNumbersPinyin: string): string {
  return `${character}::${toneNumbersPinyin}`;
}

export const getGraphemePinyinImageList = onetime((): readonly GraphemePinyinImageEntry[] => []);

const getGraphemePronunciationImageMap = onetime(() => {
  const graphemePronunciationImageMap = new Map<string, string>();
  for (const entry of getGraphemePinyinImageList()) {
    const key = pronunciationKey(entry.character, entry.toneNumbersPinyin);
    if (!graphemePronunciationImageMap.has(key)) {
      graphemePronunciationImageMap.set(key, entry.urlPath);
    }
  }
  return graphemePronunciationImageMap;
});

export function getGraphemePronunciationImageUrlPath(
  character: string,
  toneNumbersPinyin: string,
): string | null {
  return (
    getGraphemePronunciationImageMap().get(pronunciationKey(character, toneNumbersPinyin)) ?? null
  );
}
